/**
 * Module dependencies.
 */

import useBreakpoint from 'use-breakpoint';

/**
 * Breakpoints.
 */

const BREAKPOINTS = {
  desktop: 1280,
  mobile: 0,
  mobileLarge: 576,
  tablet: 769,
  tabletAir: 821,
};

/**
 * `BreakpointType` type.
 */

type BreakpointType = 'mobile' | 'tablet' | 'tabletAir' | 'desktop';

/**
 * Export `useBreakpoints` hook.
 */

export function useBreakpoints(type?: BreakpointType) {
  return useBreakpoint(BREAKPOINTS, type);
}
